module.exports = "/packs/media/images/icons/timeismoney2-2de2b9be8c41cb4c432164ee18fdfe1e.png";